import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Typography, Chip, Switch } from '@mui/material';
import { MoreVert as MoreIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import useCurrency from '../../../../hooks/common/useCurrency';

const TYPE_LABELS = {
    flat:        { ar: 'سعر ثابت',     en: 'Flat' },
    weight_based:{ ar: 'حسب الوزن',    en: 'Weight-based' },
    free:        { ar: 'مجاني',        en: 'Free' },
    tiered:      { ar: 'متدرج',        en: 'Tiered' },
};

const ShippingMethodsTableRow = ({
    item,
    index = 0,
    isSelected,
    onRowCheckboxClick,
    onMenuOpen,
    onToggleActive,
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || 'en';
    const isArabic = lng.startsWith('ar');
    const { format: formatPrice } = useCurrency();

    const name = item.name?.[lng] || item.name?.en || item.name?.ar || '-';
    const typeMeta = TYPE_LABELS[item.type] || { ar: item.type, en: item.type };
    const min = item.min_weight_grams ?? null;
    const max = item.max_weight_grams ?? null;
    const weightRange =
        min == null && max == null
            ? '-'
            : `${min ?? 0} - ${max ?? '∞'}`;

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox checked={isSelected} onClick={(e) => onRowCheckboxClick(e, item.id)} />
            </TableCell>

            <TableCell align="start">{index + 1}</TableCell>

            <TableCell>
                <Typography variant="body2" fontWeight="medium">{name}</Typography>
            </TableCell>

            <TableCell align="center">
                <Chip
                    size="small"
                    label={isArabic ? typeMeta.ar : typeMeta.en}
                    color={item.type === 'free' ? 'success' : 'primary'}
                    variant="tonal"
                    sx={{ fontWeight: 'bold', borderRadius: '6px' }}
                />
            </TableCell>

            <TableCell align="center">
                <Typography variant="body2" fontWeight="medium">
                    {item.type === 'free' ? (isArabic ? 'مجاني' : 'Free') : formatPrice(item.price ?? 0)}
                </Typography>
            </TableCell>

            <TableCell align="center">
                <Typography variant="body2">{weightRange}</Typography>
            </TableCell>

            <TableCell align="center">
                <Typography variant="body2">
                    {item.zone?.name?.[lng] || item.zone?.name?.en || item.zone?.name || '-'}
                </Typography>
            </TableCell>

            <TableCell align="center">
                <Switch
                    checked={!!item.is_active}
                    onChange={() => onToggleActive?.(item)}
                    color="primary"
                    size="small"
                />
            </TableCell>

            <TableCell align="center">
                <IconButton size="small" onClick={(e) => onMenuOpen(e, item)}>
                    <MoreIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default ShippingMethodsTableRow;
